import { TPanel } from "@/lib/constants";
import { ChildProviderProps } from "@/types";
import React, {
  useState,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from "react";

export interface PanelContextType {
  panelType: TPanel;
  setPanelType: Dispatch<SetStateAction<TPanel>>;
}

export const PanelContext = createContext<PanelContextType | undefined>(
  undefined
);

export const PanelProvider: React.FC<ChildProviderProps> = ({ children }) => {
  const [panelType, setPanelType] = useState<TPanel>(null);

  return (
    <PanelContext.Provider value={{ panelType, setPanelType }}>
      {children}
    </PanelContext.Provider>
  );
};

export const usePanel = (): PanelContextType => {
  const context = useContext(PanelContext);
  if (!context) {
    throw new Error("usePanel must be used within a PanelProvider");
  }
  return context;
};
